module.exports = __webpack_public_path__ + "static/img/news1.9daa1c07.png";